
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  height: 100%;
  place-self: stretch;
  display: block;
  overflow: hidden;
  position: relative;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}@media (min-width: 768px) {:host {
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
  }
}

:host([image-rounded='true']) img {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}

@media (min-width: 768px) {:host([image-rounded='true']) img {
    border-radius: 0.5rem;
  }
}

:host([image-rounded='true']) span.overlay {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}

@media (min-width: 768px) {:host([image-rounded='true']) span.overlay {
    border-radius: 0.5rem;
  }
}

:host([image-rounded='false']) img {
  border-radius: 0px;
}

:host a {
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
}

.card {
  height: 100%;
  justify-content: flex-start;
  place-self: stretch;
  align-items: stretch;
  display: flex;
  flex-direction: column;
}

@media (min-width: 768px) {.card {
    flex-direction: row;
  }
}

@media (min-width: 768px) {.card.image-position--top, .card.media-position--top {
    flex-direction: column;
  }
}

a:focus .card-title {
  outline-offset: 2px;
  outline-width: 3px;
  outline-style: solid;
  outline-color: #4299e1;
}

.text-variant--default outline-heading, .text-variant--default idb-heading, .text-variant--default [slot='metrics'] .metric-value {
  color: var(--blue-responsible-darken-1);
}

.text-variant--default a:focus .card-title, .text-variant--default a:hover .card-title {
  color: var(--blue-responsible-darken-1);
}

.text-variant--default a:focus .card-title, .text-variant--default a:hover .card-title {
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline;
}

.text-variant--default .card-content {
  color: var(--gray-professional-lighten-1);
}

.text-variant--default .card-summary {
  font-weight: var(--fw-bold);
}

.text-variant--default .card-summary {
  color: var(--gray-professional-darken-2);
}

.text-variant--dark outline-heading, .text-variant--dark idb-heading {
  color: var(--neutral-black);
}

.text-variant--dark a:focus .card-title, .text-variant--dark a:hover .card-title {
  color: var(--neutral-black);
}

.text-variant--dark a:focus .card-title, .text-variant--dark a:hover .card-title {
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline;
}

.text-variant--dark .card-content, .text-variant--dark .metrics {
  color: var(--neutral-black);
}

.text-variant--dark .card-summary {
  font-weight: var(--fw-bold);
}

.text-variant--dark .card-summary {
  color: var(--neutral-black);
}

.text-variant--light outline-heading, .text-variant--light idb-heading {
  color: var(--neutral-white);
}

.text-variant--light a:focus .card-title, .text-variant--light a:hover .card-title {
  color: var(--neutral-white);
}

.text-variant--light a:focus .card-title, .text-variant--light a:hover .card-title {
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline;
}

.text-variant--light .card-content, .text-variant--light .metrics {
  color: var(--neutral-white);
}

.text-variant--light .card-summary {
  font-weight: var(--fw-bold);
}

.text-variant--light .card-summary {
  color: var(--neutral-white);
}

.card-image {
  position: relative;
}

.card-image img {
  height: 100%;
}

.card-image img {
  max-height: 100%;
}

.card-image img {
  width: 100%;
}

.card-image img {
  max-width: 100%;
}

.card-image img {
  border-radius: 0.5rem;
}

.card-image img {
  object-fit: cover;
}

@media (min-width: 768px) {.card-image, .card-video {
    width: 48%;
  }
}

.image-type--video-thumbnail idb-icon {
  position: absolute;
  z-index: 50;
  font-size: var(--fs-5xl);
  line-height: var(--lh-5xl);
  color: var(--neutral-white);
  top:45%;
  left:45%;
  filter:drop-shadow(0 0 0.75rem var(--blue-responsible-lighten-3));
}

.image-type--video-thumbnail idb-icon:hover {
  color: var(--blue-responsible-darken-2);
}

span.overlay {
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  z-index: 40;
  height: 98.5%;
  width: 100%;
  background-color: var(--gray-professional-darken-2);
  opacity: 0.4;
}

@media (min-width: 768px) {span.overlay {
    height: 100%;
  }
}

.card-content-wrapper {
  display: flex;
  height: 100%;
  flex-direction: column;
  padding: 0px;
}

@media (min-width: 768px) {.card-content-wrapper {
    padding-left: 3rem;
    padding-right: 3rem;
  }.card-content-wrapper {
    width: 52%;
  }
}

.outline-bg-light-blue .card-content-wrapper, .outline-bg-gray .card-content-wrapper, .outline-bg-green .card-content-wrapper, .outline-bg-blue .card-content-wrapper {
  display: flex;
  height: 100%;
  flex-direction: column;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-bottom: 1.5rem;
  padding-top: 1rem;
}

@media (min-width: 768px) {.outline-bg-light-blue .card-content-wrapper, .outline-bg-gray .card-content-wrapper, .outline-bg-green .card-content-wrapper, .outline-bg-blue .card-content-wrapper {
    padding: 1.5rem;
  }.outline-bg-light-blue .card-content-wrapper, .outline-bg-gray .card-content-wrapper, .outline-bg-green .card-content-wrapper, .outline-bg-blue .card-content-wrapper {
    width: 52%;
  }
}

:host([inset='true']) .card-content-wrapper {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-bottom: 1.5rem;
  padding-top: 1rem;
}

@media (min-width: 768px) {:host([inset='true']) .card-content-wrapper {
    padding: 1.5rem;
  }
}

.card-cta {
  display: flex;
  flex-grow: 1;
  place-items: center;
  align-items: flex-end;
}

@media (min-width: 768px) {.media-position--top image-type--image .card-image, .media-position--top .card-video, .media-position--top .card-content-wrapper {
    width: 100%;
  }
}

.vertical-content-align--bottom{
  margin-top:auto;
}

.vertical-content-align--center{
  margin:auto 0;
}

@media (min-width: 768px) {.media-position--left .card-image, .media-position--left .card-video {
    order: 1;
  }
}

@media (min-width: 768px) {.media-position--left .card-content-wrapper {
    order: 2;
  }
}

@media (min-width: 768px) {.media-position--right .card-image, .media-position--right .card-video {
    order: 2;
  }
}

@media (min-width: 768px) {.media-position--right .card-content-wrapper {
    order: 1;
  }
}

:host([embedded-within-alt-container='true']) .media-position--right .card-content-wrapper {
  padding-left: 1rem;
}

@media (min-width: 768px) {:host([embedded-within-alt-container='true']) .media-position--right .card-content-wrapper {
    padding-left: 0.5rem;
  }
}

@media (min-width: 1440px) {:host([embedded-within-alt-container='true']) .media-position--right .card-content-wrapper {
    padding-left: 0px;
  }
}

:host([embedded-within-slider='true']) .card-title {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

:host([embedded-within-slider='true']) idb-heading,
  :host([embedded-within-slider='true']) idb-styled-text{
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-line-clamp:3;
    -webkit-box-orient:vertical;
  }

:host([embedded-within-slider='true']) idb-styled-text{
    -webkit-line-clamp:5;
  }

:host([embedded-within-slider='true']) .card-content-wrapper {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

@media (min-width: 768px) {:host([embedded-within-slider='true']) .card-content-wrapper {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
}

@media (min-width: 1024px) {:host([embedded-within-slider='true']) .card-content-wrapper {
    width: 40%;
  }
}

:host([embedded-within-slider='true']) .card-content, :host([embedded-within-slider='true']) .card-eyebrow {
  display: none;
}

@media (min-width: 768px) {:host([embedded-within-slider='true']) .card-content, :host([embedded-within-slider='true']) .card-eyebrow {
    display: block;
  }
}

:host([embedded-within-slider='true']) .card-content {
  margin-bottom: 1rem;
}

@media (min-width: 1024px) {:host([embedded-within-slider='true']) .card-image, :host([embedded-within-slider='true']) .card-video {
    width: 60%;
  }
}

@media (min-width: 1280px) {:host([embedded-within-slider='true']) .card-image {
    max-height: 550px;
  }
}

:host([embedded-within-slider='true']) .card-image img{
      object-position:top;
      object-fit:cover;
      width:100%;
      height:100%;
    }

:host([show-content]) .card-content, :host([show-content]) .card-eyebrow {
  display: block;
}

@media screen and (max-width: 768px){
    :host([embedded-within-slider='true']) .card-content-wrapper {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

@media (min-width: 1024px) {.card.banner--50-50 .card-content-wrapper, .card.banner--50-50 .card-image, .card.banner--50-50 .card-video {
    width: 50%;
  }
}

.card.banner--50-50 .card-image {
  aspect-ratio: 1.47;
}

.card.banner--50-50 .card-image {
  max-width: 100%;
}

@media (min-width: 768px) {.card.banner--50-50 .card-image {
    aspect-ratio: auto;
  }
}

.content-alignment--left {
  align-items: flex-start;
  text-align: left;
}

.content-alignment--center {
  align-items: center;
  text-align: center;
}

.content-alignment--right {
  align-items: flex-end;
  text-align: right;
}

.cta-alignment--left {
  place-self: start;
}

.cta-alignment--center {
  place-self: center;
}

.cta-alignment--right {
  place-self: end;
}

.title-alignment--left, .eyebrow-alignment--left {
  text-align: left;
}

.title-alignment--center, .eyebrow-alignment--center {
  text-align: center;
}

.title-alignment--right, .eyebrow-alignment--right {
  text-align: right;
}

.content-mode--compact .card-title, .content-mode--compact .card-content {
  padding-bottom: 0.25rem;
}

@media (min-width: 768px) {.content-mode--compact .card-title, .content-mode--compact .card-content {
    padding-bottom: 0.5rem;
  }
}

.content-mode--spacious .card-content {
  padding-bottom: 0.5rem;
}

.content-mode--spacious .card-content-wrapper {
  display: block;
}

.content-mode--spacious .card-content-wrapper .card-cta {
  display: block;
}

.content-mode--spacious .card-content-wrapper .card-cta {
  text-align: center;
}

.content-mode--spacious .card-title {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

@media (min-width: 1024px) {.content-mode--spacious .card-title {
    padding-left: 7rem;
    padding-right: 7rem;
  }
}

.content-mode--spacious .card-summary, .content-mode--spacious .card-content {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

@media (min-width: 1024px) {.content-mode--spacious .card-summary, .content-mode--spacious .card-content {
    padding-left: 13rem;
    padding-right: 13rem;
  }
}

.card-eyebrow, .card-title, .card-content {
  width: 100%;
}

.card-eyebrow {
  display: block;
  padding-bottom: 0px;
}

.outline-shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.outline-rounded-2xl {
  border-radius: 1rem;
}

.outline-bg-light-blue {
  background-color: var(--blue-responsible-lighten-5);
}

.outline-bg-blue {
  background-color: var(--blue-responsible-lighten-4);
}

.outline-bg-gray {
  background-color: var(--gray-professional-lighten-4);
}

.outline-bg-green {
  background-color: var(--green-guarantee-lighten-4);
}

.outline-bg-white {
  background-color: var(--neutral-white);
}

.outline-bg-transparent {
  background-color: var(--neutral-transparent);
}

@media (max-width: 768px){
  .card-content-wrapper{
    padding-top:1rem;
    padding-bottom:0;
  }
}

.metrics {
  margin-bottom: 0.5rem;
  min-width: 90%;
}`;